import {Injectable} from "@angular/core";
import {ClientConfiguration} from "../configuration/client.config";
import {BugsnagService} from "./bugsnag.service";
import {ErrorType, Severity} from "../../constants";

@Injectable()
export class BugsnagLoggingService {

    private _logBufferMaxSize = 20000; // max length of logging buffer in characters
    private _logBuffer = "";
    private loggingTemplate = "{product}: {message}";

    private static format(template: string, args: object): string {
        let str = template;
        Object.keys(args).forEach((arg) => {
            str = str.replace("{" + arg + "}", args[arg]);
        });
        return str;
    }

    constructor(private config?: ClientConfiguration,
                private bugsnagService?: BugsnagService) {
    }

    public log(logMsg: string): void {
        let logString = BugsnagLoggingService.format(this.loggingTemplate, {product: "RA 2.0", message: logMsg});
        this.addToLogBuffer(logString);
        console.log(logString);
    }

    public error(logMsg: string, type?: ErrorType): void {
        let logString = BugsnagLoggingService.format(this.loggingTemplate, {
            product: "RA 2.0",
            message: logMsg
        });
        if (this.bugsnagService && this.config && !this.config.superUser) {
            this.bugsnagService.notify(logString, Severity.ERROR, type);
        }
        this.log(logMsg);
    }

    // TODO: not using this level currently
    public warning(logMsg: string, type?: ErrorType): void {
        let logString = BugsnagLoggingService.format(this.loggingTemplate, {
            product: "RA 2.0",
            message: logMsg
        });
        if (this.bugsnagService && this.config && !this.config.superUser
            && this.config.logLevel !== Severity.ERROR) {
            this.bugsnagService.notify(logString, Severity.WARNING, type);
        }
        this.log(logMsg);
    }

    public info(logMsg: string): void {
        let logString = BugsnagLoggingService.format(this.loggingTemplate, {product: "RA 2.0", message: logMsg});
        if (this.bugsnagService && this.config && !this.config.superUser &&
            (this.config.logLevel === Severity.INFO || this.config.logLevel === Severity.DEBUG)) {
            this.bugsnagService.notify(logString, Severity.INFO);
        }
        this.log(logMsg);
    }

    public debug(logMsg: string): void {
        let logString = BugsnagLoggingService.format(this.loggingTemplate, {product: "RA 2.0", message: logMsg});
        if (this.bugsnagService && this.config && !this.config.superUser
            && this.config.logLevel === Severity.DEBUG) {
            // bugsnag only has an info level to send to in this case
            this.bugsnagService.notify(logString, Severity.INFO);
            // to avoid console spam, only log debug messages to console if level is set
            this.log(logMsg);
        }
    }



    private addToLogBuffer(logString: string): void {
        this._logBuffer = this._logBuffer + logString + "\n";
        if (this._logBuffer.length > this._logBufferMaxSize) {
            this._logBuffer = this._logBuffer.slice(this._logBuffer.length - this._logBufferMaxSize);
        }
    }

    public set logBufferMaxSize(size: number) {
        this._logBufferMaxSize = size;
    }

    public get logBuffer(): string {
        return this._logBuffer;
    }
}

